export const SET_ARTICLE = "SET_ARTICLE";

export const setArticle = (dispatch, payload) => {
  dispatch({ type: SET_ARTICLE, payload });
};
